import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { adminApi, apiError } from '../../lib/adminApi';
import { SOCIALS } from '../../components/SocialIcons';
import { Save, Loader2 } from 'lucide-react';

const input = 'w-full bg-black border border-white/15 rounded-lg px-4 py-2.5 text-white text-sm outline-none focus:border-red-500';

export default function SocialSettings() {
  const [links, setLinks] = useState({});
  const [pixel, setPixel] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get('/social/config').then((r) => { setLinks(r.data.links); setPixel(r.data.meta_pixel_id || ''); });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put('/admin/social/config', { links, meta_pixel_id: pixel });
      toast.success('Impostazioni social salvate');
    } catch (e) { toast.error(apiError(e)); }
    setSaving(false);
  };

  return (
    <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5 space-y-4" data-testid="social-settings">
      <div>
        <h3 className="text-white font-bold">Profili social sul sito</h3>
        <p className="text-white/40 text-xs mt-1">Le icone appaiono nel footer solo per i profili compilati.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {SOCIALS.map(({ key, label, Icon }) => (
          <label key={key} className="flex items-center gap-3">
            <Icon className="w-5 h-5 text-white/50 shrink-0" />
            <input data-testid={`social-link-${key}`} className={input} placeholder={`https://… (${label})`}
              value={links[key] || ''} onChange={(e) => setLinks({ ...links, [key]: e.target.value })} />
          </label>
        ))}
      </div>
      <div>
        <label className="text-white/60 text-xs uppercase tracking-widest">Meta Pixel ID (pubblicità)</label>
        <input data-testid="meta-pixel-input" className={`${input} mt-2`} placeholder="es. 1234567890123456"
          value={pixel} onChange={(e) => setPixel(e.target.value)} />
        <p className="text-white/40 text-xs mt-1">Lo trovi in Meta Events Manager → Origini dati. Traccia visite, carrello, checkout e acquisti.</p>
      </div>
      <button data-testid="social-settings-save" onClick={save} disabled={saving}
        className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-colors">
        {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Salva
      </button>
    </div>
  );
}
